/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationZoneResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationZone.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotationZone/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
